import { call, put, all, takeEvery } from "redux-saga/effects";
import { allocatedResourcesActions, generalActions } from "../actions";
import api from "../services/allocatedResources.service";
import ACTIONS from "../constants";

function* getResources(state) {
  try {
    yield put(allocatedResourcesActions.getResourcesAttempt.pending);
    const resources = yield call(
      api.getAllocatedResourcesRequest,
      state.payload
    );
    const pagination = JSON.parse(resources.headers["x-pagination"]);
    const data = {
      data: resources.data,
      pagination: pagination,
    };
    yield put(allocatedResourcesActions.getResourcesAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(allocatedResourcesActions.getResourcesAttempt.error(""));
    } else {
      yield put(
        allocatedResourcesActions.getResourcesAttempt.error(error.message)
      );
    }
  }
}

function* sortResources(state) {
  try {
    yield put(allocatedResourcesActions.sortResourcesAttempt.pending);
    const resources = yield call(
      api.sortAllocatedResourcesRequest,
      state.payload
    );
    const pagination = JSON.parse(resources.headers["x-pagination"]);
    const data = {
      data: resources.data,
      pagination: pagination,
    };
    yield put(allocatedResourcesActions.sortResourcesAttempt.success(data));
  } catch (error) {
    yield put(allocatedResourcesActions.sortResourcesAttempt.error(error));
  }
}

function* updateResourceFlag(state) {
  try {
    yield put(allocatedResourcesActions.updateResourceFlagAttempt.pending);
    yield call(api.updateAllocatedResourceFlagRequest, state.payload);
    yield put(allocatedResourcesActions.updateResourceFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Allocated resource flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(allocatedResourcesActions.updateResourceFlagAttempt.error(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(ACTIONS.RESOURCES_CALL, getResources)]);
  yield all([takeEvery(ACTIONS.SORT_RESOURCES_CALL, sortResources)]);
  yield all([takeEvery(ACTIONS.RESOURCE_FLAG_CALL, updateResourceFlag)]);
}
